import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(main)/error.tsx");
